export default {
	SpecialConsumptionProducst: function(state) {
		return state.SpecialConsumptionProducst;
	},

	EnviromentTaxProducts: function(state) {
		return state.EnviromentTaxProducts;
	},

	EnviromentFeesProducts: function(state) {
		return state.EnviromentFeesProducts;
	},
	FeesChargesProducts: function(state) {
		return state.FeesChargesProducts;
	},
	TypeWorks: function(state) {
		return state.TypeWorks;
	}
};
